import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Parte } from './partes.model';
import { PartesService } from './partes.service';
import { Select2Data } from 'ng-select2-component';
import { ArbitrosService } from '../arbitros/arbitros.service';
import { getCurrentLanguage } from '../core/helpers/utils';
import { AuthenticationService } from '../core/service/auth.service';
import { User } from '../core/models/auth.models';

@Component({
  selector: 'app-detail-parte',
  templateUrl: './detail-parte.component.html',
  styleUrls: ['./detail-parte.component.scss']
})
export class DetailParteComponent implements OnInit {

  @Input() parteId: string | null = null;
  @Output() changePartesView = new EventEmitter<{ view: string }>();

  nacionalidades: Select2Data = [];

  currentLanguage: string = getCurrentLanguage();

  error: string = '';
  loaded: boolean = false;
  disableNoAdmin: boolean = true;
  disableInvoicingOptions: boolean = false;

  parte: Parte = {
    tipo_parte: '',
    cif: '',
    razon_social: '',
    direccion: '',
    codigo_postal: '',
    poblacion: '',
    provincia: '',
    nacionalidad: '',
    comentarios: '',
    impuesto_aplicable: '',
    porcentaje_imputable: ''
  };

  constructor(
    private partesService: PartesService,
    private arbitrosService: ArbitrosService,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {

    this.authService.currentUser().subscribe(user => {

      if (user?.nivel_acceso === "ADMIN")
        this.disableNoAdmin = false;

      if (user){
        this.loadNacionalidades(user);        
      }
      
    })
  }

  loadNacionalidades(user:User) {
    this.arbitrosService.getNacionalidades().subscribe({
      
      next: (data) => {
        const dataNacionalidadesFromDB = data;
        const convertedNacionalidadesData = dataNacionalidadesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item[this.currentLanguage]
        }));
        this.nacionalidades = convertedNacionalidadesData;
        //this.loaded = true;
        if (this.parteId) {
          this.loadParte(user?.id);
        }
      },
      error: (error) => {
        console.error('Error loading nacionalidades:', error);
        this.error = error;
        this.loaded = false;
      }
    });
  }

  loadParte(id: string | undefined) {
    this.partesService.getParte(this.parteId!).subscribe({
      next: (data) => {
        this.parte = data;

        this.parte.porcentaje_imputable = this.formatDecimalForInput(this.parte.porcentaje_imputable);
  
        // Asignar correctamente el valor de nacionalidad usando nacionalidadData
        if (data.nacionalidadData) {
          this.parte.nacionalidad = data.nacionalidadData.codigo_alfa2;
        }
  
        // Verificar si 'parteParticipantes' y los participantes existen antes de acceder
        if (this.parte && Array.isArray(this.parte['parteParticipantes'])) {
          const participanteEncontrado = this.parte['parteParticipantes'].some(participante =>
            participante?.participante?.id_usuario === id
          );
  
          // Verificar si el usuario es representante de la parte, en tal caso sí debo dejarlo modificar los datos de la parte
          if (participanteEncontrado) {
            this.disableNoAdmin = false;
            this.disableInvoicingOptions = true;
          }
        }
        this.loaded = true;
      },
      error: (error) => {
        console.error('Error loading parte:', error);
        this.error = error;
        this.loaded = false;
      }
    });
  }
  
  onPorcentajeImputableChange(value: string | number | null | undefined) {
    const formatted = this.formatDecimalForInput(value);
    if (formatted !== (value ?? '').toString()) {
      this.parte.porcentaje_imputable = formatted;
    }
  }

  private formatDecimalForInput(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return value.toString().replace(/\./g, ',');
  }

  navigateToList(): void {
    this.changePartesView.emit({ view: 'list' });
  }

  onSubmit(form: NgForm) {
    if (this.parteId) {

      // Convertir los valores a decimal usando parseFloat, manejando correctamente los tipos
      const impuestoAplicable = parseFloat(
        typeof form.value.impuesto_aplicable === 'string'
          ? form.value.impuesto_aplicable.replace(',', '.')
          : form.value.impuesto_aplicable || '0'
      );

      const porcentajeImputable = parseFloat(
        typeof form.value.porcentaje_imputable === 'string'
          ? form.value.porcentaje_imputable.replace(',', '.')
          : form.value.porcentaje_imputable || '0'
      );

      const parte: Parte = {
        id: this.parteId,
        tipo_parte: form.value.tipo_parte,
        cif: form.value.cif,
        razon_social: form.value.razon_social,
        direccion: form.value.direccion,
        codigo_postal: form.value.codigo_postal,
        poblacion: form.value.poblacion,
        provincia: form.value.provincia,
        nacionalidad: form.value.nacionalidad,
        comentarios: form.value.comentarios,
        impuesto_aplicable: !isNaN(impuestoAplicable) ? impuestoAplicable.toString() : '0',
        porcentaje_imputable: !isNaN(porcentajeImputable) ? porcentajeImputable.toString() : '0'
      };

      //console.log("parte",parte)

      this.partesService.updateParte(this.parteId, parte)
        .subscribe(res => {
          this.navigateToList();
        },
          (error: any) => {
            console.error('Error updating parte:', error);
          });
    }
  }
}
